import { Modal } from "antd";
import BtnEditSvg from "../Button/btnEditSvg";
import { useState } from "react";
import Loader from "../../loader/loader";

import LeavePolicyGroupStatus from "../leavePolicyGroupStatus";
import LeavePolicyGroupAddSinglePopup from "./LeavePolicyGroupAddSinglePopup";

const LeavePolicyGroupPopup = ({ data }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loading, setLoading] = useState(false);
  
    const showModal = () => {
      setIsModalOpen(true);
    };
  
    const handleOk = () => {
      setIsModalOpen(false);
    };
  
    const handleCancel = () => {
      setIsModalOpen(false);
    };
  
    return (
      <>
        <button onClick={showModal} className="mt-4 mr-2">
          <BtnEditSvg size={25} />
        </button>
        <Modal
          title="Edit Leave Policy"
          open={isModalOpen}
          onOk={handleOk}
          onCancel={handleCancel}
        >
          {!loading ? (
            <>
              <LeavePolicyGroupStatus
                list={data}
                edit={true}
                setLoading={setLoading}
              />
              <LeavePolicyGroupAddSinglePopup
                list={data}
                setLoading={setLoading}
              />
            </>
          ) : (
            <Loader />
          )}
        </Modal>
      </>
    );
  };

  export default LeavePolicyGroupPopup;
  